import moment from 'moment';
import { Cell } from '@table-library/react-table-library/table';

const keysFunction = (_, page, exploreUrlLink, t) => [
    {
        key: (d) => {
            return d.title || d.page;
        },
        render: (d) => {
            let title = d.title;

            if (!d.title) {
                title = d.page;
            }

            return (
                <div style={{ width: '100%' }} className="list-col">
                    <div
                        className="w-100 d-flex align-items-center"
                        style={{ paddingTop: 10, paddingBottom: 10 }}
                    >
                        <div style={{ marginRight: '10px', width: '100px' }}>
                            <img
                                onError={(event) =>
                                    (event.target.src = '/static/img/placeholder-img.png')
                                }
                                src={d.image ?? '/static/img/placeholder-img.png'}
                                style={{
                                    width: '100px',
                                    display: 'inline-block',
                                    minHeight: '60px',
                                    background: '#BBB',
                                    borderRadius: '8px',
                                }}
                                loading="lazy"
                            />
                        </div>
                        <div className="w-100">
                            {/*<p>{ title.length > 90 ? title.substr(0, 90) + '...' : title }</p>*/}
                            <p className="text-title d-flex justify-content-between">
                                <span>
                                    {title}{' '}
                                    <a
                                        target="_blank"
                                        className="link-website d-inline-flex align-items-center justify-content-center"
                                        href={page}
                                        rel="noreferrer"
                                    >
                                        <i className="icon-external-link"></i>
                                    </a>
                                </span>
                                <a
                                    className="button button-primary button-filled"
                                    href={exploreUrlLink}
                                >
                                    {t('discover.page.card.explore_url_link')}
                                </a>
                            </p>
                            <div className="additional-info align-center d-flex align-items-center">
                                <strong>
                                    {t('discover.page.card.published')}:{' '}
                                    {d?.published?.value ?? '-'}
                                </strong>
                                <strong>
                                    {t('discover.page.card.modified')}: {d?.modified?.value ?? '-'}
                                </strong>
                                <strong>
                                    {t('discover.page.card.author')}:{' '}
                                    {(
                                        <a
                                            className="text-success fw-bold"
                                            href={
                                                `/domains/${window.info.id}/authors/author?author=` +
                                                window.encodeURIComponent(d.author)
                                            }
                                        >
                                            {d.author}
                                        </a>
                                    ) ?? '-'}
                                </strong>
                            </div>
                        </div>
                    </div>
                </div>
            );
        },
        label: 'Page',
        type: 'label',
        classes: 'col-6 d-flex align-items-center justify-content-center',
    },
];

export const COLUMNS = (t) => [
    {
        label: t('discover.page.article_history.title'),
        key: 'title',
        data: 'title',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            const title = data;
            return (
                <div>
                    <div className="d-flex align-items-center">
                        <div style={{ display: 'contents' }}>
                            <img
                                onError={(event) =>
                                    (event.target.src = '/static/img/placeholder-img.png')
                                }
                                src={item.image ?? '/static/img/placeholder-img.png'}
                                style={{
                                    background: '#BBB',
                                    width: '70px',
                                    borderRadius: '8px',
                                    objectFit: 'cover',
                                }}
                                alt="page_image"
                                loading="lazy"
                            />
                        </div>
                        <div style={{ marginLeft: '8px' }}>
                            <strong className="word-break">{title}</strong>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('discover.page.article_history.headline'),
        key: 'headline',
        data: 'headline',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div className="d-flex text-wrap">{data}</div>;
        },
    },
    {
        label: t('discover.page.article_history.author'),
        key: 'author',
        data: 'author',
        Component: Cell,
    },
    {
        label: t('discover.page.article_history.ogtitle'),
        key: 'ogtitle',
        data: 'ogtitle',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div className="d-flex text-wrap">{data}</div>;
        },
    },
    {
        label: t('discover.page.article_history.schema'),
        key: 'schema',
        data: 'schema',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div className="d-flex text-wrap">{data}</div>;
        },
    },
    {
        label: t('discover.page.article_history.words'),
        key: 'words',
        data: 'words',
        Component: Cell,
    },
    {
        label: t('discover.page.article_history.firstSeen'),
        key: 'firstSeen',
        data: 'firstSeen',
        Component: Cell,
        renderCell: ({ data }) => {
            return moment(data?.value).format('YYYY-MM-DD');
        },
    },
    {
        label: t('discover.page.article_history.modified'),
        key: 'modified',
        data: 'modified',
        Component: Cell,
        renderCell: ({ data }) => {
            return moment(data?.value).format('YYYY-MM-DD');
        },
    },
    {
        label: t('discover.page.article_history.published'),
        key: 'published',
        data: 'published',
        Component: Cell,
        renderCell: ({ data }) => {
            return moment(data?.value).format('YYYY-MM-DD');
        },
    },
];

export default keysFunction;
